import Price from '@/price/Price'
import Typography from '@ui/typography'
import React from 'react'
import { View } from 'react-native'
import { PaymentVariant } from './types'
import { colors } from '@ui/colors'
import { NumberUtils } from '@ca/common'

type Props = {
  variant: PaymentVariant
  value: number
  total: number
  showPercentage?: boolean
}

const colorVariant: Record<PaymentVariant, string> = {
  left: colors.red[600],
  processing: colors.amber[500],
  paid: colors.green[500],
  total: colors.text,
}

export default function PaymentAmount({
  variant,
  value,
  total,
  showPercentage = true,
}: Props) {
  const color = value > 0 ? colorVariant[variant] : colors.text

  return (
    <View className="flex flex-row items-center justify-end gap-2">
      <Typography variant="SMB" color={color}>
        <Price value={value} showZero />
      </Typography>
      {showPercentage && (
        <View className="flex w-10 flex-row items-center justify-end">
          <Typography
            variant="SMB"
            color={color}
            className="text-right opacity-50"
          >
            {NumberUtils.percentage.getSafe(value, total).toFixed(0)}%
          </Typography>
        </View>
      )}
    </View>
  )
}
